var generateStyle = function generateStyle(componentTheme) {
  return {
    card: {
      paddingBottom: '0',
      marginBottom: '0',
      marginTop: '0'
    },
    label: {
      padding: componentTheme.labelPadding,
      paddingLeft: componentTheme.labelLeftPadding,
      paddingBottom: componentTheme.labelBottomPadding,
      fontSize: componentTheme.labelFontSize,
      color: componentTheme.labelColor
    },
    content: {
      padding: "".concat(componentTheme.contentTopBottomPadding, " ").concat(componentTheme.contentLeftRightPadding)
    },
    wrapper: {
      paddingBottom: '0',
      paddingLeft: '0',
      paddingRight: '0'
    }
  };
};
export default generateStyle;